import { useLayoutEffect } from 'react'
import { useLocation, useMatches } from 'react-router-dom'
import type { KeptTab } from '../lib/keptTabs'
import { markRouteCommitted, routeLabel } from '../lib/perfNavigation'

// Mounted in RootLayout, whose layout effect runs in the commit that shows the
// destination route.
export function usePerfRouteTracking(tabs: readonly KeptTab[]) {
  const { pathname } = useLocation()
  const matches = useMatches()
  const params = matches[matches.length - 1]?.params ?? {}
  const route = routeLabel(pathname, params)
  useLayoutEffect(() => {
    markRouteCommitted(pathname, route, tabs)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one mark per pathname; route derives from it and tabs is static
  }, [pathname])
}
